export enum LoginFormFlow {
  GENERIC_STEP = "GENERIC_STEP",
  SAML_SSO_STEP = "SAML_SSO_STEP",
  OTP_STEP = "OTP_STEP",
  MFA_STEP = "MFA_STEP",
  FORGET_PASSWORD = "FORGET_PASSWORD",
}
